export default __webpack_public_path__ + "static/media/guitarist-1.0cfdc605.png";